import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  TemplateRef,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { PageDTO } from '@app/infrastructure/core/services/api/day-page.service';
import { DayPageFacade } from '@app/infrastructure/core/services/day-page.facade';
import {
  DayBlockPayloadDTO,
  IDayBlockDTO,
} from '@app/infrastructure/models/day-block';
import {
  GradeUnitDayDTO,
  GradeUnitDayListItemDTO,
  IGradeUnitDayDTO,
  IGradeUnitDayListItemDTO,
} from '@app/infrastructure/models/grade-unit/grade-unit-day';

@Component({
  selector: 'app-shared-grade-unit-day-detail-presentation',
  templateUrl: './grade-unit-day-detail-presentation.component.html',
  styleUrls: ['./grade-unit-day-detail-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedGradeUnitDayDetailPresentationComponent implements OnInit {
  @Input() gradeUnitDay?: IGradeUnitDayDTO;
  @Input() unitImage: string;
  @Input() days: GradeUnitDayListItemDTO[];
  @Output() emitSelection = new EventEmitter();
  public blocks: IDayBlockDTO[] = [];

  public get titleHeader(): string {
    if (this.gradeUnitDay?.dayStartPage && this.gradeUnitDay?.dayEndPage)
      return `Day ${this.gradeUnitDay.dayNumber} Pages ${this.gradeUnitDay.dayStartPage}-${this.gradeUnitDay.dayEndPage}`;
    else if (this.gradeUnitDay?.dayStartPage)
      return `Day ${this.gradeUnitDay?.dayNumber} Page ${this.gradeUnitDay?.dayStartPage}`;
    else return `Day ${this.gradeUnitDay?.dayNumber}`;
  }

  constructor(
    private dayPageFacade: DayPageFacade,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.dayPageFacade.initialize(this.gradeUnitDay.id);
    this.dayPageFacade.blocksObs$.subscribe((blocks) => {
      this.blocks = blocks;
      this.cd.markForCheck();
    });
  }

  public get activePage(): PageDTO {
    return this.dayPageFacade.activePage;
  }

  goToPreviousPage() {
    this.dayPageFacade.goToPreviousPage();
  }

  goToNextPage() {
    this.dayPageFacade.goToNextPage();
  }

  isFirstPage() {
    return this.dayPageFacade.isFirstPage();
  }

  isLastPage() {
    return this.dayPageFacade.isLastPage();
  }

  selectPage(event) {
    this.emitSelection.emit(event);
  }
}
